import type {
  AptosWallet,
  MinimallyRequiredFeatures,
} from '@aptos-labs/wallet-standard';

const REQUIRED_FEATURES: (keyof MinimallyRequiredFeatures)[] = [
  'aptos:account',
  'aptos:connect',
  'aptos:disconnect',
  'aptos:network',
  'aptos:onAccountChange',
  'aptos:onNetworkChange',
  'aptos:signMessage',
  'aptos:signTransaction',
];

export const hasAllRequiredFeatures = (wallet: AptosWallet): boolean => {
  return Boolean(
    REQUIRED_FEATURES.every((feature) => feature in wallet.features)
  );
};
